import { forwardRef, useState } from 'react';

import { cn } from '@shared/utils';

import { EyeIcon } from '../EyeIcon/EyeIcon';
import type { InputProps } from '../Input/Input';

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>(
  function PasswordInput(
    { className, invalid, 'aria-invalid': ariaInvalidProp, onFocus, onBlur, ...rest },
    ref,
  ) {
    const [showPassword, setShowPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const ariaInvalid = ariaInvalidProp ?? (invalid === true ? 'true' : undefined);

    return (
      <div className="relative">
        <input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          aria-invalid={ariaInvalid}
          onFocus={(e) => {
            setIsFocused(true);
            onFocus?.(e);
          }}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          className={cn(
            'w-full h-14 rounded-sm border bg-[#FFFFFF] px-3 pr-10 text-base text-[#181D26]',
            'placeholder:text-[#A4A7AE]',
            'outline-hidden transition-[border-color,box-shadow]',
            'focus:border-2 focus:border-[#00467D]',
            'disabled:cursor-not-allowed disabled:opacity-60',
            invalid === true ? 'border-2 border-[#F04438]' : 'border border-[#D5D7DA]',
            className,
          )}
          {...rest}
        />
        {isFocused ? (
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault();
              setShowPassword((prev) => !prev);
            }}
            className="absolute right-3 top-1/2 -translate-y-1/2 focus-visible:outline-hidden"
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
            tabIndex={-1}
          >
            <EyeIcon />
          </button>
        ) : null}
      </div>
    );
  },
);
